import React from 'react';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import styles from './AdditionalCoverages.module.scss';
import { landingText } from '@/utils/generalTexts';
import AdditionalCoveragesCard from './AdditionalCoveragesCard';
import { clickActionsEvents, trackClick } from '@/utils/dataLayer/home';

type AdditionalCoveragesT = {
  id: string;
  icon: string;
  iconBrackground: string;
  label: {
    text: string;
    color: string;
    background: string;
  };
  title: string;
  subtitle: string;
  onClick: (router?: any) => void;
  alt: string;
  description: string;
}[];

const AdditionalCoverages = ({
  cards,
  customClass,
}: {
  cards: AdditionalCoveragesT;
  customClass?: string;
}) => {
  const router = useRouter();

  return (
    <div className={styles.additional_coverages_container}>
      <div className={classnames(customClass)}>
        <div className={styles.additional_coverages_header}>
          <div className={styles.additional_coverages_title}>{landingText.pymeValue.title}</div>
          <div className={styles.additional_coverages_subtitle}>
            {landingText.pymeValue.subtitle}
          </div>
        </div>
        <div className={styles.additional_coverages_cards_container}>
          {cards.map((card) => (
            <AdditionalCoveragesCard
              key={card.id}
              id={card.id}
              icon={card.icon}
              iconBrackground={card.iconBrackground}
              label={card.label}
              title={card.title}
              subtitle={card.subtitle}
              onClick={() => {
                trackClick({
                  action: clickActionsEvents.btnAdditionalCoverage(card.description),
                });
                card.onClick(router);
              }}
              alt={card.alt}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdditionalCoverages;
